export const PROJECT_VARIABLES = {
    environments: {
        LOCAL: 'local',
        DEVELOPMENT: 'development',
        DEVELOPMENT_CSD: 'development_csd',
        DEVELOPMENT_PD: 'development_pd',
        ACCEPTANCE: 'acceptance',
        PRODUCTION: 'production'
    },
    api_server: {
        LOCAL: 'http://localhost:5500',
        DEVELOPMENT: 'https://api-development.relayter.com',
        ACCEPTANCE: 'https://api-acceptance.relayter.com',
        PRODUCTION: 'https://api.relayter.com'
    },
    oauth_client_id: '2rUWCLq1jzZzLPB9zEak1ZA3qaggbg50'
};
